<template>
  <div id="reader">
    <div class="reader-container">
      <div class="block">
        <span class="demonstration"><i class="fa fa-volume-down"></i></span>
        <el-slider v-model="value2"  :step="0.1" :min="0" :max="3"></el-slider>
      </div>
      <div id="book-container" class="book-container" :style="`font-size: ${letter}px`">
        <!-- v-show="text != '\r'" -->
        <p v-for="(word, index) in bookCurrentPage" :key="word + index">
          <span v-show="word != '\r'" :id="word" ref="word">{{ word }}</span>
        </p>
      </div>
      <!-- {{bookCurrentPage}} -->
    </div>
    <div class="paginador">
      <button type="button" @click="firstPage">
        <img src="@/assets/img/dobleArrow.png" alt />
      </button>
      <button type="button" @click="previusPage">
        <img src="@/assets/img/arrowNextBook.png" alt />
      </button>
      <div>
        <span class="index-number">{{ currentPage }}</span>
      </div>
      <button type="button" @click="nextPage">
        <img src="@/assets/img/arrowNextBook-right.png" alt />
      </button>
      <button type="button" @click="lastPage">
        <img src="@/assets/img/dobleArrowFlip.png" alt />
      </button>
    </div>
 
    <div class="tools-buttons">
      <!-- <button @click="changeVolumeCtrl" type="button"><img src="@/assets/icons/volume.png" alt=""></button>
      <div v-show="changeVolumeSlider" class="help-box">
        <input v-model="volume" type="range" name="volume-slider" min="30" max="50" id="volume-slider">
      </div>-->
      <button type="button" @click="newNewReader">
        <i class="fa fa-play"></i>
      </button>
      <button type="button" @click="stopReader">
        <i class="fa fa-stop"></i>
      </button>
      <!-- <button @click="pauseReader" type="button"><img src="@/assets/icons/pause.png" alt=""></button> -->
      <button type="button" @click="changeSizeCtrl">
        <i class="fa fa-font"></i>
      </button>
      <!-- <button @click="changeSizeCtrl" type="button"><img src="@/assets/icons/size.png" alt=""></button> -->
      <div v-show="changeSizeSlider" class="help-box letter-size">
        <input id="size-slider" v-model="letter" type="range" min="16" max="30" name="size-slider" />
      </div>
      <button type="button" @click="sendToPrint">
        <i class="fa fa-print"></i>
      </button>
      <!-- <button @click="sendToPrint" type="button"><img src="@/assets/icons/print.png" alt=""></button> -->
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import speechUtteranceChunker from '@/mixins/chunkify';
import store from '@/store';

export default {
  name: 'Reader',
  // props: ['text'],
  data() {
    return {
      value2:1,
      text: '',
      arrayCounter: 0,
      volume: 0,
      letter: 16,
      value: 3,
      timeout: 0,
      book: [],
      synth: window.speechSynthesis,
      isReaderStopped: false,
      isReaderPlaying: false,
      bookToSpeech: [],
      newBook: '',
      currentPage: 0,
      minValue: 0,
      maxValue: 0,
      numberPerPage: 20,
      numberOfPages: 1,
      bookCurrentPage: [],
      changeVolumeSlider: false,
      changeSizeSlider: false,
      bookContainer: {},
    };
  },
  watch: {
    arrayCounter: function (val) {
      this.book[val].onstart = e => {
        document.getElementById(e.currentTarget.text).style.background = '#FFFF00';
        document.getElementById(e.currentTarget.text).style.borderRadius = '25px';
        document.getElementById(e.currentTarget.text).style.border = '5px solid #FFFF00';
        document.getElementById(e.currentTarget.text).style.transition = 'all 1s';
      };
      this.book[val].onend = e => {
        document.getElementById(e.currentTarget.text).style.background = 'transparent';
        document.getElementById(e.currentTarget.text).style.borderRadius = '0px';
        document.getElementById(e.currentTarget.text).style.border = '0px solid #FFFF00';
        document.getElementById(e.currentTarget.text).style.transition = 'all 1s';
        if (this.arrayCounter < this.book.length - 1) {
          this.arrayCounter++;
        } else {
          this.arrayCounter = 0;
        }
      };
    },
  },
  created() {},
  mounted() {},
  beforeRouteEnter: (to, from, next) => {
    store.commit('app/START_PROCESSING');
    Vue.prototype.$httpMain
      .post(`book`, {
        diskname: `${to.params.diskname}`,
        zip_file: `${to.params.zip_file}`,
      })
      .then(res => {
        next(vm => {
          store.commit('app/STOP_PROCESSING');
          // console.log(res.data);
          vm.insertText(res.data);
        });
      })
      .finally(() => {
        store.commit('app/STOP_PROCESSING');
      });
  },
  beforeDestroy() {
    // Stop reader
    this.stopReader();
  },
  methods: {
    newNewReader() {
      if (this.synth.speaking === false) {
        // console.log('HOLA@')
        for (var section in this.bookCurrentPage) {
          // this.bookCurrentPage[section]
          this.book[section] = new SpeechSynthesisUtterance(this.bookCurrentPage[section]);
          this.book[section].lang = 'en-US';
          let voices = this.synth.getVoices();
          this.book[section].voice = voices[0]; //Microsoft David Desktop, default voice
          this.book[section].rate = this.value2;
          this.synth.speak(this.book[section]);
        }
        this.book[0].onstart = e => {
          // console.log(this.arrayCounter, 'array')
          console.log(document.getElementById(e.currentTarget.text));
          document.getElementById(e.currentTarget.text).style.background = '#FFFF00';
          document.getElementById(e.currentTarget.text).style.borderRadius = '25px';
          document.getElementById(e.currentTarget.text).style.border = '5px solid #FFFF00';
          document.getElementById(e.currentTarget.text).style.transition = 'all 1s';
        };
        this.book[0].onend = e => {
          document.getElementById(e.currentTarget.text).style.background = 'transparent';
          document.getElementById(e.currentTarget.text).style.borderRadius = '0px';
          document.getElementById(e.currentTarget.text).style.border = '0px solid #FFFF00';
          document.getElementById(e.currentTarget.text).style.transition = 'all 1s';
          this.arrayCounter++;
        };
      }
    },
    insertText(res) {
      this.text = res;
      this.newBook = this.text.split(/[.\n]/);
      this.nextPage();
      window.scrollTo(0, 0);
      this.bookContainer = this.$el.querySelector('#book-container');
      this.getNumberOfPages();
    },
    changeSizeCtrl() {
      if (this.changeSizeSlider === false) {
        this.changeSizeSlider = true;
      } else {
        this.changeSizeSlider = false;
      }
    },
    changeVolumeCtrl() {
      if (this.changeVolumeSlider === false) {
        this.changeVolumeSlider = true;
      } else {
        this.changeVolumeSlider = false;
      }
    },
    sendToPrint() {
      print();
    },
    getNumberOfPages() {
      this.numberOfPages = Math.ceil(this.newBook.length / this.numberPerPage);
      return this.numberOfPages;
    },
    firstPage() {
      // Stop reader
      this.stopReader();
      this.bookContainer.scrollTop = 0;
      this.arrayCounter = 0;
      this.currentPage = 1;
      this.loadList();
    },
    previusPage() {
      // Stop reader
      this.stopReader();
      this.bookContainer.scrollTop = 0;
      this.arrayCounter = 0;
      if (this.currentPage > 1) {
        this.currentPage -= 1;
      }
      this.loadList();
    },
    nextPage() {
      // Stop reader
      this.stopReader();
      this.bookContainer.scrollTop = 0;
      this.arrayCounter = 0;
      // console.log('Hola')
      if (this.currentPage < this.numberOfPages) {
        this.currentPage += 1;
      }
      this.loadList();
    },
    lastPage() {
      // Stop reader
      this.stopReader();
      this.bookContainer.scrollTop = 0;
      this.arrayCounter = 0;
      this.currentPage = this.numberOfPages;
      this.loadList();
    },
    loadList() {
      var begin = (this.currentPage - 1) * this.numberPerPage;
      var end = begin + this.numberPerPage;

      this.bookCurrentPage = this.newBook.slice(begin, end);
      // check()
    },
    pauseReader() {
      if (this.synth.speaking === true) {
        this.synth.pause();
      }
    },
    stopReader() {
      if (this.synth.speaking === true) {
        this.synth.cancel();
        this.arrayCounter = 0;
      }
    },

    newReader() {
      this.isReaderPlaying = true;
      this.isReaderStopped = false;
      if (document.getElementById(this.arrayCounter.toString())) {
        var position = document.getElementById(this.arrayCounter.toString()).offsetTop;
        this.bookContainer.scrollTo(0, position);
        // console.log(position)
        document.getElementById(this.arrayCounter.toString()).style.background = '#FFFF00';
        document.getElementById(this.arrayCounter.toString()).style.borderRadius = '25px';
        document.getElementById(this.arrayCounter.toString()).style.border = '5px solid #FFFF00';
        document.getElementById(this.arrayCounter.toString()).style.transition = 'all 1s';
      }
      // console.log(this.bookCurrentPage[this.arrayCounter])
      this.synth = window.speechSynthesis;
      this.book = new SpeechSynthesisUtterance(this.bookCurrentPage[this.arrayCounter]);
      // console.log(this.book)
      this.book.lang = 'en-US';
      if (this.synth.paused === true) {
        this.synth.resume();
      } else {
        this.synth.speak(this.book);
      }
      this.book.onend = () => {
        // console.log(this.bookCurrentPage[this.arrayCounter] !== undefined)
        if (this.bookCurrentPage[this.arrayCounter] !== undefined) {
          // if (this.bookCurrentPage.length) {
          //   this.nextPage()
          // }
          if (document.getElementById(this.arrayCounter.toString())) {
            document.getElementById(this.arrayCounter.toString()).style.background = 'transparent';
            document.getElementById(this.arrayCounter.toString()).style.borderRadius = '0px';
            document.getElementById(this.arrayCounter.toString()).style.border = '0px solid #FFFF00';
            document.getElementById(this.arrayCounter.toString()).style.transition = 'all 1s';
          }
          // console.log(this.bookCurrentPage.length)
          // console.log(this.arrayCounter)
          this.arrayCounter++;
          if (this.synth.speaking === false) {
            return;
          }
          this.newReader();
        } else {
          this.synth.cancel();
          this.arrayCounter = 0;
        }
      };
    },
    newReaderAux() {
      // if (this.isReaderStopped === false) {
      //   return
      // }
      // this.arrayCounter++
      if (document.getElementById(this.arrayCounter.toString())) {
        var position = document.getElementById(this.arrayCounter.toString()).offsetTop;
        this.bookContainer.scrollTo(0, position);
        // console.log(position)
        document.getElementById(this.arrayCounter.toString()).style.background = '#FFFF00';
        document.getElementById(this.arrayCounter.toString()).style.borderRadius = '20px';
        document.getElementById(this.arrayCounter.toString()).style.border = '5px solid #FFFF00';
        document.getElementById(this.arrayCounter.toString()).style.transition = 'all 1s';
      }
      console.log(this.bookCurrentPage[this.arrayCounter]);
      this.synth = window.speechSynthesis;
      this.book = new SpeechSynthesisUtterance(this.bookCurrentPage[this.arrayCounter]);
      console.log(this.book);
      this.book.lang = 'en-US';
      this.synth.speak(this.book);
      this.book.onend = () => {
        // console.log(this.bookCurrentPage[this.arrayCounter] !== undefined)
        if (this.bookCurrentPage[this.arrayCounter] !== undefined) {
          // if (this.bookCurrentPage.length) {
          //   this.nextPage()
          // }
          if (document.getElementById(this.arrayCounter.toString())) {
            document.getElementById(this.arrayCounter.toString()).style.background = 'transparent';
            document.getElementById(this.arrayCounter.toString()).style.borderRadius = '0px';
            document.getElementById(this.arrayCounter.toString()).style.border = '0px solid #FFFF00';
            document.getElementById(this.arrayCounter.toString()).style.transition = 'all 1s';
          }
          // console.log(this.bookCurrentPage.length)
          // console.log(this.arrayCounter)
          // this.arrayCounter++
          // if (this.bookCurrentPage.length === this.arrayCounter) {
          //   this.nextPage()
          // }
          this.newReader();
        } else {
          this.synth.cancel();
          this.arrayCounter = 0;
        }
      };
    },
    closeReader() {
      speechUtteranceChunker.cancel = true;
      window.speechSynthesis.cancel();
      clearTimeout(this.timeout);
      this.$emit('closeReader', false);
      this.$router.push('/reader');
    },
    $speechUtteranceChunker: function (utt, settings, callback) {
      // console.log(utt)
      var vm = this;
      settings = settings || {};
      var newUtt;
      var txt = settings && settings.offset !== undefined ? utt.text.substring(settings.offset) : utt.text;
      if (utt.voice && utt.voice.voiceURI === 'native') {
        // Not part of the spec
        newUtt = utt;
        newUtt.lang = 'en-US';
        newUtt.text = txt;
        newUtt.addEventListener('end', function () {
          // console.log(vm.speechUtteranceChunker.cancel)
          if (vm.speechUtteranceChunker.cancel) {
            vm.speechUtteranceChunker.cancel = false;
          }
          if (callback !== undefined) {
            callback();
          }
        });
      } else {
        var chunkLength = (settings && settings.chunkLength) || 160;
        var pattRegex = new RegExp(
          '^[\\s\\S]{' +
            Math.floor(chunkLength / 2) +
            ',' +
            chunkLength +
            '}[.!?,]{1}|^[\\s\\S]{1,' +
            chunkLength +
            '}$|^[\\s\\S]{1,' +
            chunkLength +
            '} ',
        );
        var chunkArr = txt.match(pattRegex);

        if (chunkArr[0] === undefined || chunkArr[0].length <= 2) {
          // call once all text has been spoken...
          if (callback !== undefined) {
            callback();
          }
          return;
        }
        var chunk = chunkArr[0];
        newUtt = new SpeechSynthesisUtterance(chunk);
        newUtt.lang = 'en-US';
        var x;
        for (x in utt) {
          /*eslint-disable */
          if (utt.hasOwnProperty(x) && x !== 'text') {
            newUtt[x] = utt[x];
          }
          /*eslint-enable */
        }
        newUtt.addEventListener('end', function () {
          // console.log(vm.speechUtteranceChunker.cancel)
          if (vm.speechUtteranceChunker.cancel) {
            vm.speechUtteranceChunker.cancel = false;
            return;
          }
          settings.offset = settings.offset || 0;
          settings.offset += chunk.length - 1;
          vm.speechUtteranceChunker(utt, settings, callback);
        });
      }

      if (settings.modifier) {
        settings.modifier(newUtt);
      }
      // console.log(newUtt) // IMPORTANT!! Do not remove: Logging the object out fixes some onend firing issues.
      // placing the speak invocation inside a callback fixes ordering and onend issues.
      setTimeout(function () {
        speechSynthesis.speak(newUtt);
      }, 0);
    },
    readBook() {
      var book = new SpeechSynthesisUtterance(this.bookCurrentPage);
      book.lang = 'en-US';
      speechUtteranceChunker(
        book,
        {
          chunkLength: 120,
        },
        function () {},
      );
    }
  },

};
</script>
<style lang="scss" scoped>
.block{
  //background: #000;
  display: grid;
  grid-template-columns: 10% 80%;
  align-items: center;
  max-width: 350px;
  padding-left: 2rem;
  .demonstration{
    font-size: 2rem;
  }
}
#reader {
  background-image: url('~@/assets/img/background-books.png');
  background-position: center center;
  background-color: #55c5cc;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.reader-container {
  position: absolute;
  top: 60px;
  left: 10px;
  right: 10px;
  bottom: 80px;
  background: #fff;
  font-family: 'comfortaaregular';
  font-size: 16px;
  line-height: 0px;
  white-space: pre-wrap;
  overflow-y: auto;
  overflow-y: none;
  border-radius: 15px;
  box-shadow: 5px 5px 15px rgba(62, 98, 45, 0.5);
}
.book-container {
  position: absolute;
  top: 34px;
  left: 40px;
  right: 22px;
  bottom: 34px;
  background: #fff;
  font-family: 'comfortaaregular';
  font-size: 40px;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-y: auto;
  overflow-y: none;
  &::-webkit-scrollbar {
    border-radius: 10px;
    background: #d1d1d1;
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    margin: 6px;
    background: #464646;
  }
}
.paginador {
  box-shadow: 5px 5px 15px rgba(62, 98, 45, 0.5);
  background: #ffd042;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  width: 300px;
  position: absolute;
  bottom: 10px;
  right: calc(50% - 150px);
  padding: 0 5px;
  button {
    background: #ffd042;
    border: 1px solid #ffd042;
    height: 50px;
    border-radius: 10px;
    margin: 0 5px;
    img {
      height: 40px;
    }
    &:focus {
      background: #d1ab37;
      border: none;
      outline: none;
    }
    &:active {
      background-color: #8c7224;
    }
  }
  div {
    display: flex;
    height: 58px;
    background: white;
    align-items: center;
    text-align: center;
    width: 50px;
    display: flex;
    justify-content: center;
  }
}
.tools-buttons {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #ffd042;
  box-shadow: 5px 5px 15px rgba(62, 98, 45, 0.5);
  border-radius: 20px;
  width: 180px;
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 5px;
  .help-box {
    z-index: 10;
    background: #ffd042;
    position: absolute;
    top: 50px;
    border-radius: 20px;
    height: 60px;
    width: 220px;
    left: 0px;
    box-shadow: 5px 5px 15px rgba($color: #3e622d, $alpha: 0.5);
    &.letter-size {
      left: 70px;
      padding: 10px;
    }
    &:after,
    &:before {
      bottom: 100%;
      left: 40px;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: rgba(136, 183, 213, 0);
      border-bottom-color: #ffd042;
      border-width: 10px;
      margin-left: -10px;
    }
    &:before {
      border-color: rgba(194, 225, 245, 0);
      border-bottom-color: #ffd042;
      border-width: 10px;
      margin-left: -10px;
    }
  }
  button {
    background: #ffd042;
    border: 1px solid #ffd042;
    height: 30px;
    border-radius: 10px;
    i {
      color: #000;
    }
    img {
      height: 25px;
    }
    &:focus {
      background: #d1ab37;
      /*border: none;*/
      outline: none;
    }
    &:active {
      background-color: #8c7224;
      box-shadow: 0 0px #666;
      transform: translateY(0px);
    }
  }
  div {
    display: flex;
    height: 58px;
    background: white;
    align-items: center;
    text-align: center;
    width: 48px;
    span {
      margin-left: calc(50% - 4.453px);
    }
  }
}
.index-number {
  font-family: 'comfortaabold';
}
input[type='range'] {
  margin: 18px 0;
  width: 100%;
}
input[type='range']:focus {
  outline: none;
}
input[type='range']::-webkit-slider-runnable-track {
  width: 100%;
  height: 8.4px;
  cursor: pointer;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  background: #3071a9;
  border-radius: 1.3px;
  border: 0.2px solid #010101;
}
input[type='range']::-webkit-slider-thumb {
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  border: 1px solid #000000;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: #ffffff;
  cursor: pointer;
  margin-top: -14px;
}
input[type='range']:focus::-webkit-slider-runnable-track {
  background: #367ebd;
}
input[type='range']::-moz-range-track {
  width: 100%;
  height: 8.4px;
  cursor: pointer;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  background: #3071a9;
  border-radius: 1.3px;
  border: 0.2px solid #010101;
}
input[type='range']::-moz-range-thumb {
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  border: 1px solid #000000;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: #ffffff;
  cursor: pointer;
}
input[type='range']::-ms-track {
  width: 100%;
  height: 8.4px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  border-width: 16px 0;
  color: transparent;
}
input[type='range']::-ms-fill-lower {
  background: #2a6495;
  border: 0.2px solid #010101;
  border-radius: 2.6px;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
}
input[type='range']::-ms-fill-upper {
  background: #3071a9;
  border: 0.2px solid #010101;
  border-radius: 2.6px;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
}
input[type='range']::-ms-thumb {
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  border: 1px solid #000000;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: #ffffff;
  cursor: pointer;
}
input[type='range']:focus::-ms-fill-lower {
  background: #3071a9;
}
input[type='range']:focus::-ms-fill-upper {
  background: #367ebd;
}
@media (max-height: 450px) {
  .tools-buttons {
    display: block;
    width: 45px;
    height: 136px;
  }
  .reader-container {
    top: 5px;
    left: 65px;
  }
}
</style>

<style>
@media print {
  .navbar-tpm,
  .sidebar-menu {
    display: none !important;
  }
  .tools-buttons {
    display: none !important;
  }
  .paginador {
    display: none !important;
  }
}
</style>
